exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#webview,\n#webview:focus {\n  outline: none;\n}\n\n.icon-container.media-container {\n  border-width: 1px;\n}\n", ""]);

// exports
